export default __webpack_public_path__ + "static/media/support_modal.620842f4.svg";